import React, { useEffect, useState } from 'react'; 
import styles from './../Assets/CSS/Style.module.css';
import faqStyles from './../Assets/CSS/Faq.module.css';
import AdPerson from './../Assets/Images/AdPerson.svg'; 
import chechCircle from './../Assets/Images/checkCircle.svg';
import shopingList from './../Assets/Images/shopping-list 1.svg';
import customer from './../Assets/Images/costumer 1.svg';
import { MdShoppingCart } from 'react-icons/md'; 
import bussinessStep from './../Assets/Images/biussinessStepImg1.svg';
import bussinessStep2 from './../Assets/Images/bussinessStep2.svg';
import bussinessStep3 from './../Assets/Images/bussinessStep3.svg';
import next from './../Assets/Images/next.svg';
import PaperSearch from './../Assets/Images/PaperSearch.svg'
import CustomerEngagement from './../Assets/Images/CustomerEngagement.svg';
import ImageUpload from './../Assets/Images/ImageUpload.svg';
import GrowBusinnessImg from './../Assets/Images/GrowBussinessAdImg.svg';
import AdsRank from './../Assets/Images/AdsRAnk.svg';
import personInfo from './../Assets/Images/PersonInfo.svg';
import AdsStats from './../Assets/Images/AdsStats.svg';
import infomartAdsImg from './../Assets/Images/InfomartAdsImg.svg';
import bussinessAd from './../Assets/Images/bussinessAd.svg';
import { BlueButton } from './../Components/Button'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from './../Environment';
import { toast } from 'react-toastify'; 
  
function FreeAds() {
    const navigate = useNavigate();
    const [accordionActiveIndex, setAccordionActiveIndex] = useState(null); 
    const [isLoading, setIsLoading] = useState(false);
    const [video, setVideo] = useState([]);
    const [faq, setFaq] = useState([]); 
    useEffect(() => {
        document.title = 'Infomart | Free Ads';
        setIsLoading(true);
        axios.get(`${BASE_URL}/video/User`, { 
            headers: { 
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {
            setVideo(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        axios.get(`${BASE_URL}/faq`, {
            headers: {  
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {
            setFaq(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);
    const handleToggleAccordion = (index) => {
        setAccordionActiveIndex(accordionActiveIndex === index ? null : index);
    };
    const handleRegister = () => {
        navigate('/client/register'); 
    } 
    return (
        <div className="app"> 
            <div className="outlet">
                {isLoading ?
                    <h5 className="text-center mt-5">Loading...</h5>
                :
                    <div className={styles.freeAdsPageContainer}>
                        <div className={styles.topSection}>
                            <div className={styles.leftSection}>
                                <h3>Lorem Ipsum is Simply Dummy text</h3>
                                <div className="text-muted my-4">Lorem ipsum is simply dummy text of the printing and typesetting industry.</div>
                                <div className={styles.row}>
                                    <BlueButton title="Start Now" onClick={handleRegister} />
                                </div>
                                <div className="my-4">
                                    {[0, 1, 2].map((i) => (
                                        <div className={`${styles.row} my-2`} key={i}>
                                            <img src={chechCircle} />
                                            <div className="text-muted">Lorem ipsum is simply dummy text of the printing.</div>
                                        </div>
                                    ))}
                                </div>
                            </div>  
                            <div className={styles.rightSection}>
                                <img src={AdPerson} className={styles.adMainImg} />
                                <div className={styles.bussinessDataCard}>
                                    <h6 className="mt-3 mx-3 lh-2 mb-4">17.1 Crore+ Buyers*</h6>
                                    <MdShoppingCart size={78} color="#acf5e9" />
                                </div>
                                <div className={`${styles.bussinessDataCard} ${styles.yellowCard}`}>
                                    <h6 className="mt-3 mx-3 lh-2 mb-4">3.8 Crore+ Business Listed</h6>
                                    <img src={customer} />
                                </div>
                                <div className={`${styles.bussinessDataCard} ${styles.pinkCard}`}>
                                    <h6 className="mt-3 mx-3 lh-2 mb-2">5.4 Lakhs Happy Customer</h6>
                                    <img src={shopingList} />
                                </div>
                            </div>
                        </div> 
                        <h1 className="my-0 mt-4 fw-bold">Get a FREE Business Listing in 3 Simple Steps</h1>
                        <div className={styles.bussinessStepSection}> 
                            {[0, 1, 2].map((i) => (
                                <> 
                                    <div className={styles.bussinessStepCard} key={i}>
                                        <div className={styles.outerBorder}>
                                            <div className={styles.innerBorder}>
                                                <img src={i === 0 ? bussinessStep : i === 1 ? bussinessStep2 : bussinessStep3} className={styles.bussinessStepImg} />
                                            </div>
                                        </div>
                                        <h4 className="text-muted mt-4">Step {i + 1}</h4>
                                        <h4>{i === 0 ? 'Create Account' : i === 1 ? 'Enter Bussiness Details' : 'Select Categories'}</h4>
                                        <div className={styles.bussinessCardDetails}>
                                            {i === 0 ?
                                                'Enter your mobile number to get started'
                                            : i === 1 ?
                                                'Add name, address, business hours and photos'
                                            :
                                                'Add relevant categories to your free listing page' 
                                            } 
                                        </div>
                                    </div>
                                    {i !== 2 && <img src={next} className={styles.nextIcon} />}
                                </>
                            ))}
                        </div>
                        <div className={styles.businessGrowSection}>
                            <h1 className="text-center mb-5 fw-bold">Connnect with New Customers & Grow Your bussiness</h1>
                            <div className={styles.row}>
                                <div className={styles.imgContainer}>
                                    <img src={GrowBusinnessImg} />
                                </div>
                                <div className={styles.right}>
                                    <div>
                                        <h4>Free Bussiness Listing Page</h4>
                                        <div className="mt-3">Having a presence on Infomart helps you build trust with your potential customers</div>
                                    </div>
                                    <div className={`${styles.item} mt-4`}>
                                        <img src={PaperSearch} />
                                        <h6>Enrich your business details so that people can find you online easily</h6>
                                    </div>
                                    <div className={styles.item}>
                                        <img src={CustomerEngagement} />
                                        <h6>Increase customer engagement by responding to their reviews and questions</h6>
                                    </div>
                                    <div className={styles.item}>
                                        <img src={ImageUpload} />
                                        <h6>Upload photos and videos to showcase your business online</h6>
                                    </div>
                                    <h4 className="mt-4">Register Your Bussiness Today</h4>
                                    <div className={styles.item}> 
                                        <BlueButton title="Start Now" onClick={handleRegister} />
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div className={styles.infoMartAdsSection}>
                            <div className={styles.left}>
                                <h3>Infomart Ads</h3>
                                <div className="my-2 fs-5">Get prominent display over your competitors and reach out to more customers.</div>
                                <div className={styles.item}>
                                    <img src={AdsRank} />
                                    <h6 className="fs-5">Rank higher in search and get more exposure in front of your potential customers.</h6>
                                </div>
                                <div className={styles.item}>
                                    <img src={personInfo} />
                                    <h6 className="fs-5">Rank higher in search and get more exposure in front of your potential customers.</h6>
                                </div>
                                <div className={styles.item}>
                                    <img src={AdsStats} />
                                    <h6 className="fs-5">Rank higher in search and get more exposure in front of your potential customers.</h6>
                                </div>
                                <div>
                                    <BlueButton title="Advertise Now" onClick={handleRegister} />
                                </div>
                            </div> 
                            <div className={styles.right}>
                                <div className={styles.imgContainer}>
                                    <img src={infomartAdsImg} />
                                </div>
                            </div>
                        </div>
                        <div className={faqStyles.faqSection}>
                            <h1>Frequently Asked Questions</h1> 
                            <div className={faqStyles.accordionList}>
                                {faq?.map((data, i) => (
                                    <div className={faqStyles.accordionItem} key={i}>
                                        <h2 className="accordion-header" id={`heading${i}`}>
                                            <button className={`accordion-button p-2 ${accordionActiveIndex === i ? '' : 'collapsed'}`} type="button" onClick={() => handleToggleAccordion(i)} aria-expanded={accordionActiveIndex === i} aria-controls={`collapse${i}`}>
                                                {data.question}
                                            </button>
                                        </h2> 
                                        <div id={`collapse${i}`} className={`accordion-collapse collapse ${accordionActiveIndex === i ? 'show' : ''}`} aria-labelledby={`heading${i}`} data-bs-parent="#accordionExample">
                                            <div className="accordion-body p-2">
                                                {data.answer} 
                                            </div> 
                                        </div> 
                                    </div> 
                                ))} 
                            </div> 
                            {/* <BlueButton title="See All" rightIcon={<IoChevronDown />} /> */}
                        </div>   
                        <div className={styles.professionalBussinessSection}>
                            <h2>Learn How to Make Your Business Profile Look More Professional</h2>
                            <div className={styles.successInnerSection}>
                                {video.slice(0, 3).map((video, i) => {
                                    const videoId = new URL(video.link).searchParams.get('v');
                                    const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : video.link;
                                    return (
                                        <div className="video-card" key={i}>
                                            <h3>{video.title}</h3> 
                                            <iframe width="100%" height="180" src={embedUrl} title={video.title} frameBorder="0" allowFullScreen></iframe>
                                            <p className="mb-0">{video.sub_title}</p> 
                                            <p className="date-added">
                                                <b>Added On:</b> {new Date(video.created_at).toLocaleDateString()}
                                            </p>
                                        </div> 
                                    ); 
                                })} 
                            </div>  
                        </div>
                        <div className={styles.bussinessListCreate}>
                            <div className={styles.main}>
                                <div className={styles.innerSection}>
                                    <h2>List Your Business on Infomart Today</h2>
                                    <div className="text-muted w-60">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                                    <div className={styles.row}>
                                        <BlueButton title="Create Free Account" onClick={handleRegister} />
                                    </div> 
                                </div>
                                <div>
                                    <img src={bussinessAd} />
                                </div>
                            </div>
                        </div>
                    </div>
                } 
            </div> 
        </div> 
    );
}

export default FreeAds;      